
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTransformer01Off as ObiTransformer01OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-transformer-01-off.js';
 
 
 

 
 export const ObiTransformer01Off = createComponent({
   react: React,
   tagName: 'obi-transformer-01-off',
   elementClass: ObiTransformer01OffElement,
   events: {
     
   }
  });
 
 